export const customersColumns = ['Nome', 'Documento', 'Tipo', ''];

export const customerAccountsColumns = [
  'Banco',
  'Agência',
  'Conta',
  'Dígito',
  'Status',
  'Data Criação',
  'Saldo',
  '',
];
